import api from "api";

interface DownloadOptions {
  method?: "GET" | "POST";
  data?: Record<string, unknown>;
}

const downloadReport = async (endpoint: string, filename: string, options?: DownloadOptions): Promise<void> => {
  const response = await api.call(endpoint, options);
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export default downloadReport;
